import { render, staticRenderFns } from "./SignatureDeleteDoc.vue?vue&type=template&id=04bf07cd"
import script from "./SignatureDeleteDoc.vue?vue&type=script&lang=js"
export * from "./SignatureDeleteDoc.vue?vue&type=script&lang=js"
import style0 from "./SignatureDeleteDoc.vue?vue&type=style&index=0&id=04bf07cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports